import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useReward } from 'partycles';
import { Logo, PrimaryButton } from 'components/index';
import { selectCurrentUser } from 'ducks/user.duck';
import { manageDisableScrolling } from 'ducks/ui.duck';

import css from './OnboardingCompleteModal.module.css';

const OnboardingCompleteModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const onboardingPosition = currentUser?.attributes?.profile?.publicData?.onboardingPosition;
  const prevPosition = useRef(onboardingPosition);
  const [isOpen, setIsOpen] = useState(false);

  const anchorRef = useRef(null);
  const { reward } = useReward(anchorRef, 'confetti');

  useEffect(() => {
    if (prevPosition.current === 'share-profile' && !onboardingPosition) {
      setIsOpen(true);
    }
    prevPosition.current = onboardingPosition;
  }, [onboardingPosition]);

  useEffect(() => {
    if (isOpen) {
      const t = setTimeout(reward, 300);
      return () => clearTimeout(t);
    }
  }, [isOpen, reward]);

  useEffect(() => {
    dispatch(manageDisableScrolling('OnboardingCompleteModal', isOpen));
    return () => dispatch(manageDisableScrolling('OnboardingCompleteModal', false));
  }, [isOpen, dispatch]);

  if (!isOpen) return null;

  const handleCta = () => {
    setIsOpen(false);
    navigate('/dashboard');
  };

  return (
    <div className={css.overlay}>
      <span ref={anchorRef} className={css.confettiAnchor} />
      <div className={css.card}>
        <div className={css.content}>
          <h1 className={css.title}>You're all set up!</h1>
          <p className={css.body}>Your profile is now ready to share!</p>
          <p className={css.body}>
            Once you start taking bookings, you'll be able to see your revenue, manage your class
            sessions and registers on the dashboard:
          </p>
          <PrimaryButton className={css.cta} onClick={handleCta}>
            Go to dashboard
          </PrimaryButton>
          <button className={css.closeLink} onClick={() => setIsOpen(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingCompleteModal;
